import { EnvironmentProviders, inject, provideEnvironmentInitializer, Provider } from '@angular/core';
import { ApplicationStore, getModuleGroupByName, SOFTLINE_FEATURE_APPLICATIONS } from '@softline/application';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { default as deTitles } from '../i18n/de.titles.json';
import { artikelinfoRoutes } from './artikelinfo.routes';
import { provideArtikelinfoGlobals } from './artikelinfo.globals';
import { EntityGuard } from './guard/entity.guard';
import { SOFTLINE_PERMISSION_ARTIKELINFO } from './product-scan.shared';

export function provideArtikelinfoModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'artikelinfo',
        title: '#PRODUCT_SCAN.APP',
        icon: 'fa-regular fa-memo-circle-info',
        route: '/artikelinfo',
        permission: SOFTLINE_PERMISSION_ARTIKELINFO,
        group: getModuleGroupByName('Handel'),
      },
      withSoftAppsModuleRoutes({ app: artikelinfoRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      }),
      withSoftAppsModuleInfo({
        library: '@softapps/handel/artikelinfo',
        description: 'Artikelinfo per Scan im Handel.',
      })
    ),
    ...provideArtikelinfoGlobals(),
  ];
}

export const artikelinfoProviders: (Provider | EnvironmentProviders)[] = [
  provideEnvironmentInitializer(() => {
      const store = inject(Store);
      store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
        module: 'artikelinfo',
        language: 'de',
        translations: de
      });
      store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
        name: '#PRODUCT_SCAN.APP',
        icon: 'fa-regular fa-memo-circle-info',
        route: '/artikelinfo',
        permission: SOFTLINE_PERMISSION_ARTIKELINFO,
        group: getModuleGroupByName('Handel')
      });
    }),
  EntityGuard
];
